import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { Card, CardBody } from "reactstrap";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import {
  getAllApprovalList,
  updateApprovalStatus,
} from "../../api/casp/approval";
import { Action, PerPage } from "../../constants/Common";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import { ApprovalModule, Modules } from "../../constants/Module";
import { ApprovalStatuses, ChangeRequestStatus } from "../../constants/Status";
import NodataFound from "../../Components/Common/NoDataFound";
import Ticket from "../../assets/images/icons/ticket.png";
import CommentModal from "../../Components/casp/common/CommentModal";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import ApprovalIcon from '@mui/icons-material/Approval';
import { withTranslation } from "react-i18next";

function ChangeRequestApprovalList(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [columns, setColumn] = useState([]);
  const [triggerState, setTriggerState] = useState(+new Date());
  const [open, setOpen] = useState(false);
  const [getApprovalId, setGetApprovalId] = useState(0);
  const [getParamsApiObj, setGetParamsApiObj] = useState();
  const [getStatus, setGetStatus] = useState();
  const [mounted, setMounted] = useState(false);
  const { project } = useParams()

  const handleClickOpen = (approvalId, paramsApiObj, status) => {
    setOpen(true);
    setGetApprovalId(approvalId);
    setGetParamsApiObj(paramsApiObj);
    setGetStatus(status);
  };

  const handleClose = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setOpen(false);
    setGetApprovalId(0);
    setGetParamsApiObj();
    setGetStatus();
  };

  const handleTriggerAdd = (status, comments) => {
    const updatedParamsApiObj = {
      ...getParamsApiObj,
      comments: comments,
    };
    handleApproval(getApprovalId, updatedParamsApiObj, status);
    handleClose();
  };

  const handleApproval = async (approvalId, paramsApiObj, status) => {
    try {
      setIsLoading(true);
      const updatedParamsApiObj = { ...paramsApiObj }; // Create a copy of paramsApiObj
      updatedParamsApiObj.status = status;
      const res = await updateApprovalStatus(
        parseInt(approvalId),
        updatedParamsApiObj
      );
      if (page === 0) {
        setTriggerState(+new Date());
      } else {
        setPage(0);
        setTriggerState(+new Date());
      }
      if (status === ApprovalStatuses.APPROVED) {
        toast.success(res.data.message);
      }
      if (status === ApprovalStatuses.REJECTED) {
        toast.info(res.data.message);
      }
    } catch (errors) {
      setIsLoading(false);
      toast.error("Something went wrong.");
      setTriggerState(+new Date());
    }
  };

  const getApprovalList = async ({ page = 1, perPage = 5 }) => {
    try {
      setIsLoading(true);
      const ApprovalParams = {
        userId: loggedInUser.id,
        projectId: parseInt(project),
        perPage: perPage,
        page,
        filterFields: [
          "module",
          "status",
          "currentApprovalUser",
          "moduleProposedStatus",
        ],
        filterInputs: [
          ApprovalModule.CHANGE_REQUEST,
          ApprovalStatuses.PENDING,
          ApprovalStatuses.PENDING,
          ChangeRequestStatus.APPROVED,
        ],
      };
      const res = (await getAllApprovalList(ApprovalParams)).data.data;
      if (res.data.length > 0) {
        let approvalModuleDetails = res.data.map((approvalItem) => ({
          uniqueChangeRequestId:
            approvalItem.moduleDetails?.uniqueChangeRequestId,
          impact: approvalItem.moduleDetails?.impact,
          status: approvalItem.moduleDetails?.status,
          project: approvalItem.moduleDetails?.project,
          date: dayjs(approvalItem.moduleDetails?.createdAt).format(
            "DD.MM.YYYY"
          ),
          sections: [
            ...new Set(
              approvalItem.moduleDetails?.changeRequestItems.map(
                (item) => item.sections
              )
            ),
          ].join(", "),
          actions: Action.VIEW,
          id: approvalItem?.id,
          changeRequestId: approvalItem?.moduleDetails?.id,
          actionObj: {
            moduleId: approvalItem.moduleId,
            module: approvalItem.module,
            projectId: approvalItem.moduleDetails?.projectId,
          },
        }));
        setRows(approvalModuleDetails);
        setTotalRows(res.meta.total);
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const paginationModelMethod = async (data) => {
    if (rowsPerPage !== data.pageSize) {
      setRowsPerPage(data.pageSize);
    } else {
      setRowsPerPage(data.pageSize);
      setPage(data.page);
    }
  };

  // when chaging the tab this useEffect is used
  useEffect(() => {
    if (mounted) {
      setRows([]);
      setTotalRows(0);
      page > 0
        ? setPage(0)
        : getApprovalList({ page: page + 1, perPage: rowsPerPage });
    }
  }, [props.module]);

  // when changing the page or approved from last page this useEffect is used
  useEffect(() => {
    if (mounted) {
      getApprovalList({ page: page + 1, perPage: rowsPerPage });
    }
    const data = () => {
      setColumn([
        {
          field: "uniqueChangeRequestId",
          headerName: props.t("Change Request ID"),
          width: 150,
          flex: 1,
          filterable: false,
          sortable: false,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <div className="MuiDataGrid-cellContent">
                {params.row?.uniqueChangeRequestId}
              </div>
            </div>
          ),
        },
        {
          field: "project",
          headerName: props.t("Project"),
          headerClassName: "super-app-theme--header",
          width: 200,
          flex: 1,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                <div className="MuiDataGrid-cellContent">
                <span className="text-truncate mx-0" title={params.row?.project.name}>{params.row?.project.name}</span>
                </div>
            </div>
            ),
        },
        {
          field: "date",
          headerName: props.t("Date"),
          width: 100,
          flex: 1,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="ProjSubmissionIcon"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="MuiDataGrid-cellContent mx-0">
                {params.row.date}
              </div>
            </div>
          ),
        },
        {
          field: "sections",
          headerName: props.t("Sections"),
          headerClassName: "super-app-theme--header",
          width: 250,
          flex: 1,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                <div className="MuiDataGrid-cellContent">
                    <span className="m-2 text-truncate" title={params.row?.sections}>{params.row?.sections}</span>
                </div>
            </div>
        ),
        },
        {
          field: "impact",
          headerName: props.t("Impact"),
          headerClassName: "super-app-theme--header",
          width: 240,
          flex: 1,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                <div className="MuiDataGrid-cellContent">
                <span className="text-truncate" title={params.row?.impact}>{params.row?.impact}</span>
                </div>
            </div>
        ),
        },
        {
          field: "actions",
          headerName: props.t("Actions"),
          width: 300,
          // flex: 1,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="proSubmissionActions"
              style={{ display: "flex", alignItems: "center", width: '100%' }}
            >
              <Button
                disableElevation
                variant="contained"
                className="approveBtn"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#90EE90",
                  color: "black",
                  textTransform: "none",
                }}
                onClick={() =>
                  handleApproval(
                    params.row.id,
                    params.row.actionObj,
                    ApprovalStatuses.APPROVED
                  )
                }
              >
                <DoneIcon />
                {props.t("Approve")}
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="error"
                className="rejectBtn"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#FFC0CB",
                  color: "black",
                  textTransform: "none",
                }}
                onClick={() =>
                  handleClickOpen(
                    params.row.id,
                    params.row.actionObj,
                    ApprovalStatuses.REJECTED
                  )
                }
              >
                <ClearIcon />
                {props.t("Reject")}
              </Button>
              <Link
                to={`/project/${project}/change-request/${params.row?.changeRequestId}/details`}
                className="viewSkyBtn statusButton statusViewBtn mx-2"
              >
                <RemoveRedEyeOutlinedIcon />
              </Link>
            </div>
          ),
        },
      ]);
    };
    data();
  }, [page, triggerState, localStorage.getItem("I18N_LANGUAGE")]);

  // when changing the row perPage
  useEffect(() => {
    setRows([]);
    if (page === 0) {
      setTriggerState(+new Date());
    } else {
      setPage(0);
    }
    setMounted(true);
  }, [rowsPerPage]);

  const getRowId = (row) => row.id;

  return (
    <React.Fragment>
      <div className="page-content position-relative">
      <Helmet
        onChangeClientState={(newState, addedTags) => {
            try {
            // Check if we added any new link[rel="icon"] elements.
            const newFaviconElems = filter(get(newState, 'linkTags', []), {
                rel: 'icon',
            })

            if (!newFaviconElems.length) {
                return
            }

            // Get the href of the last link element we just added, which
            // we assume is the most recently-added favicon.
            const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href

            // Remove all react-helmet link elements with rel="icon" that
            // do not have the href of our recently-added favicon.
            // If no other favicon elements exist, we don't have to do
            // anything.
            const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
            )

            if (existingFavicons.length) {
                existingFavicons.forEach(e => e.parentNode.removeChild(e))
            }

            // Remove and re-add the latest link element to make sure
            // the browser uses it.
            const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
            )

            if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true)
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<ApprovalIcon />)}</svg>`
                  )}`
                const parentElem = newFaviconElem.parentNode
                parentElem.removeChild(newFaviconElem)
                parentElem.appendChild(newFavElement)
            }
            } catch (e) {
            console.error(e)
            }
        }}
      >
          <title>{props.t("Change Request Approval List")}</title>
      </Helmet>
        <Container fluid>
          {/* BreadCrumb area starts */}
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={props.t(props.module)} />
          </div>
          <div className="milestoneSubmission accordionTable my-4">
            <CommentModal
              handleRejectModal={handleClose}
              open={open}
              handleApproval={handleTriggerAdd}
              module={Modules.CHANGE_REQUEST}
            />
            <Card>
              <CardBody>
                <div style={{ height: 400, width: "100%" }}>
                  <Box
                    sx={{
                      height: 400,
                      width: "100%",
                      "& .super-app-theme--header": {
                        backgroundColor: "rgba(0, 173, 255, 0.55)",
                      },
                    }}
                  >
                    {rows.length > 0 && (
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{
                          pagination: {
                            paginationModel: { pageSize: rowsPerPage },
                          },
                        }}
                        pageSizeOptions={PerPage}
                        style={{ border: "unset" }}
                        paginationMode="server"
                        rowCount={totalRows}
                        key={triggerState}
                        onPaginationModelChange={paginationModelMethod}
                        loading={isLoading}
                        disableRowSelectionOnClick
                        getRowId={getRowId}
                      />
                    )}
                    {rows.length === 0 && isLoading && <Loader />}
                    {rows.length === 0 && !isLoading && (
                      <NodataFound
                        text={props.t(`No ${props.module} to show`)}
                        icon={Ticket}
                      />
                    )}
                  </Box>
                </div>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(ChangeRequestApprovalList)
